import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	frame: {
		width: '48px',
		height: '48px',
	},
	avatar: {
		width: '96px',
		height: '96px',
		transform: 'scale(0.5)',
		transformOrigin: 'top left',
	},
});

// Fit a 96px ADS xlarge avatar into the card's 48px layout without changing its appearance.
export const CardAvatarFrame = ({ children }: { children: React.ReactNode }): React.JSX.Element => (
	<Box xcss={styles.frame}>
		<Box xcss={styles.avatar}>{children}</Box>
	</Box>
);
